import { Button } from "@/components/ui/button";
import Section from "@/components/Section";
import masterclassImage from "@/assets/ai-masterclass-visual.png";

const AIMasterclass = () => {
  return (
    <Section
      eyebrow="Executive program"
      title={<>AI <span className="text-gradient-brand">Masterclass</span></>}
      description="Two half-day live sessions plus digital resources to lead your AI transformation."
    >
      <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div className="space-y-6">
          <div className="text-muted-foreground text-lg leading-relaxed space-y-4">
            <p>Accelerate your leadership journey with the AI Masterclass, a course for decision-makers and leaders seeking to understand, implement, and apply AI to generate powerful results within their organizations.</p>
            <p>Through two half-day live sessions, comprehensive digital resources, and practical assignments, you will gain both theoretical insights and hands-on tools to lead your organization's AI transformation. Discover the possibilities of AI, analyze your organization's current state, and develop an actionable plan for future-proof leadership.</p>
            <p>This program is designed for leaders and decision-makers in both public and private sectors. Choose the track that best fits your organization and become a trusted leader in an AI-driven future.</p>
          </div>

          <div className="flex flex-wrap gap-4 mt-2">
            <Button variant="secondary" size="lg" asChild>
              <a
                href="https://www.utbildning.se/kurser/ai-for-sverige/ai-for-ledare-masterclass-offentlig-sektor-2117933"
                target="_blank"
                rel="noopener noreferrer"
              >
                Public sector →
              </a>
            </Button>
            <Button variant="secondary" size="lg" asChild>
              <a
                href="https://www.utbildning.se/kurser/ai-for-sverige/ai-for-ledare-masterclass-privat-sektor-2117932"
                target="_blank"
                rel="noopener noreferrer"
              >
                Private sector →
              </a>
            </Button>
          </div>
        </div>

        <div className="relative">
          <div className="absolute -inset-2 bg-gradient-brand opacity-20 blur-2xl rounded-2xl" aria-hidden />
          <div className="relative rounded-2xl overflow-hidden aspect-square border border-border/60">
            <img
              src={masterclassImage}
              alt="AI Masterclass - Futuristic digital visualization"
              className="w-full h-full object-cover"
              loading="lazy"
              width="600"
              height="600"
            />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default AIMasterclass;
